export default {
  password: "required|max:50",
  password_confirmation: "required|confirmed:password",
  password_old: "required|max:50",
  password_new: "required|min:8|max:50",
  email: "required|email",
  email_new: "required|email|unique:email|max:50",
  email_confirmation: "required|email|confirmed:email",
  gravatar: "email",
  username:
    "required|regex:^[a-zA-Z0-9 .'_-]*$|not-email|unique:username|min:3|max:32",
  first_name: "max:50",
  last_name: "max:50",
  country_code: "required|max:2",
  state_code: "max:2",
  city: "max:50",
  address: "max:100",
  zip: "max:20",
  authCode: "required|min:6|max:6",
  appId: "required",
  captcha: "required",
  bgsltDescription: "max:25"
};
